module.exports = __webpack_public_path__ + "img/073682.8e77461f.png";